import * as React from "react"
import PropTypes from "prop-types"
import cx from "classnames"
import "./Separator.css"

export function Separator({ color = "default", vertical = false }) {
  return (
    <div
      className={cx("flex flex-row items-center justify-between Separator", {
        "border-grey-light": color === "default",
        "border-primary-dark": color === "primary",
        "border-secondary-dark": color === "secondary",
        "border-l": vertical,
        "border-t": !vertical,
      })}
    />
  )
}

Separator.propTypes = {
  color: PropTypes.oneOf(["default", "primary", "secondary", "current"]),
  vertical: PropTypes.bool,
}

export const WithSeparators = ({ children: childrenProps }) => {
  const children = React.Children.toArray(childrenProps).reduce(
    (children, element) => {
    if (children.length === 0) {
      return [element]
    }

    return children.concat(
      <Separator key={`${element.key}-separator`} />,
      element,
    )
    },
    [],
  )

  return children
}
